// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"53cd72da","598":"d3a35c4f","703":"0595d4b3"}[chunkId] + ".chunk.js";
};